import { useState } from 'react'

export const useSubmissionState = () => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [submitBtnClicked, setSubmitBtnClicked] = useState(false)

  const handleSubmission = async (isValid: boolean, submitFn: () => Promise<void>) => {
    if (isValid && !isSubmitting) {
      setSubmitBtnClicked(true)
      setIsSubmitting(true)
      try {
        await submitFn()
      } finally {
        setIsSubmitting(false)
      }
    }
  }

  return {
    isSubmitting,
    submitBtnClicked,
    handleSubmission,
  }
}
